export default function handleError(e) {
  return e.response && e.response.data && (e.response.data.message || e.response.message)
      || e.message
}